import { m } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Button, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../../components/animate';
// assets
import { ForbiddenIllustration } from '../../assets/illustrations';
import { useEffect } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

export default function Page403() {
  const { setDocumentTitle } = useAuthContext();
  const { translate } = useLocales();

  useEffect(() => {
      setDocumentTitle(`403 ${translate("Forbidden")}`);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <>
      <MotionContainer sx={{justifyContent: 'center', textAlign:"center"}}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            {translate("No permission")}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: 'text.secondary' }}>
            {translate("The page you")}&apos;{translate("re trying access has restricted access.")}
            <br />
            {translate("Please refer to your system administrator")}
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>

        <Button component={RouterLink} to="/" size="large" variant="contained">
          {translate("Go to Home")}
        </Button>
      </MotionContainer>
    </>
  );
}
